<template>
    
    <div>
        <vheader :insti="insti"/>
        <router-view/>
    </div>
    
</template>

<script>
import vheader from '@/components/header'
// import IndexVue from "./fac/Index.vue";
import constants from '@/util/constants.js';
export default {
  data() {
    return {
      token:this.$route.params.token || JSON.parse(window.localStorage.getItem("data")).data,
      insti:this.$route.params.insti || JSON.parse(window.localStorage.getItem("insti"))
    };
  },
  components: {
    vheader,
    // IndexVue,
  },
  mounted() {
    // let insti = this.insti;
    // let token = this.token;
    // this.$router.push({
    //   path: "/fac/index",
    //   name: "FacIndex",
    //   params: {
    //     insti,
    //     token
    //   }
    // });
  }
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/Fac.vue